// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__36ha-","itemTitle":"ClientEmergencyInfo_itemTitle__1VqOU","itemText":"ClientEmergencyInfo_itemText__r3mvk"};